module.exports = __webpack_public_path__ + "img/banner-campaign.ffbafe77.jpg";